import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class NotificationSendService extends BaseService{
	constructor() {
		super('/NotificationSend');
	}

	public getAllByFilter(filter: NotificationSendFilter) {
		return super.getAllByFilterBase(filter);
	}

	public readNotifications(idsList: number[]) {
		return this.updateListWithResourceName(idsList, 'read-notification');
	}

	public getCountNotificationNotRead(filter: NotificationSendFilter) {
		return this.getAllByFilterBase(filter, 'count-notification');
	}

	public sendAgain( idsList:number[]) {
		return this.updateListWithResourceName(idsList,  'send-again' );
	}

	public sendNotificationToPerson2(idPerson: number, data: any) {
		return this.updateWithResourceName(idPerson, 'send-notification-person',data );
	}

	public sendNotificationToPerson(id: number, idTemplate: number) {
		return this.updateBase(`${this._resourceName + '/' + 'send-notification-person'}/${id}/${idTemplate}`, null, { timeout: this.timeOutSet });
	}

	public getUserSendNotification(filter: NotificationSendPortalFilter) {
			return this.getAllByFilterBase(filter, 'user-send-notification');
	}

	public sendAllNotificationPortal(idPerson: number, data: any) {
		return this.updateWithResourceName(idPerson, 'send-notification-portal', data);
	}
}

export class NotificationSendFilter extends BaseFilter{
	constructor(idPerson?: number | null, idTenant?: number | null, notRead?: boolean | null, viaPortal?: boolean | null) {
		super();
		this._idPerson = idPerson;
		this._idTenant = idTenant;
		this._notRead = notRead;
		this._viaPortal = viaPortal;
	}

	private _idPerson ?: number | null;
	private _idTenant?: number | null;
	private _notRead?: boolean | null;
	private _viaPortal?: boolean | null;

	public getAllParams(): {} {
		let data = Object.assign({},			
			(this._idPerson != null ? { IdPerson: this._idPerson } : {}),
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._notRead != null ? { NotRead: this._notRead } : {}),
			(this._viaPortal != null ? { ViaPortal: this._viaPortal } : {})
			
			

		);

		return data;
	};
}


export class NotificationSendPortalFilter extends BaseFilter {
	constructor(tenantsList?: string | null, rolesList?: string | null) {
		super();
		this._tenantsListString = tenantsList;
		this._rolesListString = rolesList;

	}

	private _tenantsListString?: string | null;
	private _rolesListString?: string | null;

	//private _tenantsList?: number[] | null;
	//private _rolesList?: number[] | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._tenantsListString != null ? { TenantsListString: this._tenantsListString } : {}),
			(this._rolesListString != null ? { RolesListString: this._rolesListString} : {})
		);

		return data;
	};
}



